/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Directive, ElementRef, Provider, Renderer2, forwardRef} from '@angular/core';

import {ControlValueAccessor, NG_VALUE_ACCESSOR} from './control_value_accessor';

export const /** @type {?} */ RANGE_VALUE_ACCESSOR: Provider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => RangeValueAccessor),
  multi: true
};
/**
 * The accessor for writing a range value and listening to changes that is used by the
 * {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName} directives.
 * 
 *  ### Example
 *  ```
 *  <input type="range" [(ngModel)]="age" >
 *  ```
 */
export class RangeValueAccessor implements ControlValueAccessor {
  onChange = (_: any) => {};
  onTouched = () => {};
/**
 * @param {?} _renderer
 * @param {?} _elementRef
 */
constructor(private _renderer: Renderer2,
private _elementRef: ElementRef) {}
/**
 * @param {?} value
 * @return {?}
 */
writeValue(value: any): void {
    this._renderer.setProperty(this._elementRef.nativeElement, 'value', parseFloat(value));
  }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnChange(fn: (_: number|null) => void): void {
    this.onChange = (value) => { fn(value == '' ? null : parseFloat(value)); };
  }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnTouched(fn: () => void): void { this.onTouched = fn; }
/**
 * @param {?} isDisabled
 * @return {?}
 */
setDisabledState(isDisabled: boolean): void {
    this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector:
      'input[type=range][formControlName],input[type=range][formControl],input[type=range][ngModel]',
  host: {
    '(change)': 'onChange($event.target.value)',
    '(input)': 'onChange($event.target.value)',
    '(blur)': 'onTouched()'
  },
  providers: [RANGE_VALUE_ACCESSOR]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer2, },
{type: ElementRef, },
];
}

function RangeValueAccessor_tsickle_Closure_declarations() {
/** @type {?} */
RangeValueAccessor.decorators;
/**
 * @nocollapse
 * @type {?}
 */
RangeValueAccessor.ctorParameters;
/** @type {?} */
RangeValueAccessor.prototype.onChange;
/** @type {?} */
RangeValueAccessor.prototype.onTouched;
/** @type {?} */
RangeValueAccessor.prototype._renderer;
/** @type {?} */
RangeValueAccessor.prototype._elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../../../packages/forms/src/directives/range_value_accessor.ts